var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model, Prop, Watch } from "vue-facing-decorator";
import { SystemsClient, CompaniesClient, SitesClient, ReportScheduleModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
const systemsClient = new SystemsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let DashboardReportFilterVue = class DashboardReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.isModal = false;
        this.initialCompanyId = null;
        this.initialSiteId = null;
        this.working = false;
        this.statusFilterKey = 1;
        this.companyFilterKey = 1;
        this.companies = [];
        this.sites = [];
        //alarmTypes: Array<ListOption> = [
        //	{ text: "All alarm types", value: 0 },
        //	{ text: "Block Voltage Alarms", value: 1 },
        //	{ text: "Block Ohmic Alarms", value: 2 },
        //	{ text: "Block Temperature Alarms", value: 3 },
        //];
        //systemStates: Array<SelectableListOption> = [
        //	{ selected: true, value: "critical", text: "Critical" },
        //	{ selected: true, value: "warning", text: "Warning" },
        //	{ selected: true, value: "healthy", text: "Ok" },
        //	{ selected: true, value: "unknown", text: "Offline" }
        //];
        this.companyIds = [];
        this.siteId = null;
        //alarmType: ListOption = this.alarmTypes[0];
        this.hideSiteName = false;
        this.recentAlarmsPeriod = 7;
        //get numberOfSeletedStatus() {
        //	return this.systemStates.filter(item => item.selected).length;
        //};
        //get statusOptionText() {
        //	if (this.numberOfSeletedStatus == this.systemStates.length)
        //		return `All statuses`;
        //	if (this.numberOfSeletedStatus != 1)
        //		return this.systemStates.filter(item => item.selected).map(item => item.text).join(", ");
        //	return this.systemStates.filter(item => item.selected)[0]?.text;
        //};
        //selectStatus(item: SelectableListOption): void {
        //	this.ensureOneStatusSelected(!item.selected, item);
        //};
        //ensureOneStatusSelected(checked: boolean, item: SelectableListOption): void {
        //	if (this.numberOfSeletedStatus <= 1) {
        //		item.selected = true;
        //		this.statusFilterKey++;
        //		return;
        //	}
        //	item.selected = checked;
        //};
        //getComponentKey(item: SelectableListOption) {
        //	return 'status-' + item.value + this.statusFilterKey;
        //}
    }
    created() {
        this.getLookups();
    }
    mounted() {
        this.loadReportScheduleQuery();
    }
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || "",
                        selected: false
                    };
                });
                this.companies = companies;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        var currentTimezoneOffset = moment().utcOffset();
        var startTimezoneOffset = moment().add('days', (this.recentAlarmsPeriod - 1) * -1).utcOffset();
        return {
            currentTimezoneOffset: currentTimezoneOffset,
            startTimezoneOffset: startTimezoneOffset,
            companyIds: this.companyIds.length > 0 ? this.companyIds : undefined,
            siteId: this.siteId,
            hideSiteName: this.hideSiteName,
            recentAlarmsPeriod: this.recentAlarmsPeriod
        };
    }
    generateSummaryStatusReport() {
        this.working = true;
        var reportQuery = this.getQuery();
        systemsClient
            .downloadSystemSummaryStatusAsPdf(reportQuery)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download the report.");
                return;
            }
            //DownloadUtil.handleFileDownload(response);
            let blob = new Blob([response.data], { type: 'application/pdf;base64' });
            let url = URL.createObjectURL(blob);
            var popUp = window.open(url, '_blank');
            if (popUp == null || typeof (popUp) == 'undefined') {
                alert('Please disable your pop-up blocker and try again.');
            }
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    exportToCsv() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        this.working = true;
        systemsClient.downloadSystemSummaryStatusAsCsv(query)
            .then(response => {
            if (!response) {
                Notifier.onWarning("Could not download report data.");
                return;
            }
            DownloadUtil.handleFileDownload(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    onShowModal() {
        if (this.showModal) {
            if (this.initialCompanyId) {
                this.companyIds = [this.initialCompanyId];
                this.selectCompanyById(this.initialCompanyId);
            }
            //if (this.alarmType?.value === 0)
            //	this.systemStates = this.initialSystemStates ?? this.systemStates;
            setTimeout(() => {
                this.working = true;
                this.siteId = this.initialSiteId;
                this.working = false;
            }, 10);
        }
    }
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery();
    }
    schedule() {
        var reportQuery = this.getQuery();
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            this.working = true;
            var query = JSON.parse(queryString);
            this.companyIds = query.companyIds || [];
            if (this.companyIds.length > 0) {
                this.companyIds.forEach(id => this.selectCompanyById(id));
            }
            this.siteId = query.siteId;
            this.recentAlarmsPeriod = query.recentAlarmsPeriod;
            this.hideSiteName = query.hideSiteName;
            this.$nextTick(() => {
                this.working = false;
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    onCompanyIdsChanged() {
        if (!this.working) {
            // Clear site selection if multiple companies are selected or no companies
            if (this.companyIds.length !== 1) {
                this.siteId = null;
            }
        }
    }
    //@Watch("alarmType")
    //onAlarmTypeChanged(): void {
    //	if (this.alarmType?.value == 0) {
    //		this.systemStates = [
    //			{ selected: true, value: "critical", text: "Critical" },
    //			{ selected: true, value: "warning", text: "Warning" },
    //			{ selected: true, value: "healthy", text: "Ok" },
    //			{ selected: true, value: "unknown", text: "Offline" }
    //		];
    //		return;
    //	}
    //	this.systemStates = [
    //		{ selected: true, value: "critical", text: "Critical" },
    //		{ selected: true, value: "warning", text: "Warning" }
    //	];
    //}
    get numberOfSelectedCompanies() {
        return this.companies.filter(item => item.selected).length;
    }
    ;
    get companyOptionText() {
        var _a;
        if (this.numberOfSelectedCompanies === 0)
            return `All companies`;
        if (this.numberOfSelectedCompanies === 1)
            return (_a = this.companies.filter(item => item.selected)[0]) === null || _a === void 0 ? void 0 : _a.text;
        return `${this.numberOfSelectedCompanies} companies selected`;
    }
    ;
    get canSelectAll() {
        return this.numberOfSelectedCompanies < this.companies.length;
    }
    ;
    get canUnselectAll() {
        return this.numberOfSelectedCompanies > 0;
    }
    ;
    get isSiteDropdownDisabled() {
        return this.numberOfSelectedCompanies > 1;
    }
    ;
    selectCompany(item) {
        item.selected = !item.selected;
        this.updateCompanyIds();
    }
    ;
    selectAllCompanies() {
        this.companies.forEach(item => item.selected = true);
        this.updateCompanyIds();
    }
    ;
    unselectAllCompanies() {
        this.companies.forEach(item => item.selected = false);
        this.updateCompanyIds();
    }
    ;
    selectCompanyById(companyId) {
        const company = this.companies.find(c => c.value === companyId);
        if (company) {
            company.selected = true;
            this.updateCompanyIds();
        }
    }
    ;
    updateCompanyIds() {
        this.companyIds = this.companies.filter(item => item.selected).map(item => item.value);
        this.companyFilterKey++;
    }
    ;
    getCompanyComponentKey(item) {
        return 'company-' + item.value + this.companyFilterKey;
    }
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => this.companyIds.length === 0 || this.companyIds.includes(site.companyId));
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteId = item.value;
    }
    ;
};
__decorate([
    Model,
    __metadata("design:type", Boolean)
], DashboardReportFilterVue.prototype, "showModal", void 0);
__decorate([
    Prop,
    __metadata("design:type", Boolean)
], DashboardReportFilterVue.prototype, "isModal", void 0);
__decorate([
    Prop,
    __metadata("design:type", Object)
], DashboardReportFilterVue.prototype, "initialCompanyId", void 0);
__decorate([
    Prop,
    __metadata("design:type", Object)
], DashboardReportFilterVue.prototype, "initialSiteId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], DashboardReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("showModal"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportFilterVue.prototype, "onShowModal", null);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("companyIds"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardReportFilterVue.prototype, "onCompanyIdsChanged", null);
DashboardReportFilterVue = __decorate([
    Component({
        name: "DashboardReportFilterVue",
        emits: ["schedule", "updateSchedule"]
    })
], DashboardReportFilterVue);
export default DashboardReportFilterVue;
